import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  FormFieldSet,
  PageHeader,
  PageTitle,
} from "../../../../components";
import { useDispatch, useSelector } from "react-redux";
import {
  addToDraft,
  getVendorOneStart,
  updateVendorStart,
} from "../../../../redux/slices/vendor/vendorSlice";
import { debounce } from "../../../../utils";

const Comments = ({ setActiveTab, isEditable, editVendor = "", vendorId }) => {
  const [comment, setComment] = useState("");
  const dispatch = useDispatch();

  const vendorProfileUiid = useSelector(
    (state) => state.vendor.vendorProfileUiid
  );
  const vendorDetails = useSelector(
    (state) => state.vendor.currentVendor.vendorDetails
  );
  useEffect(() => {
    console.log("vendorProfileUiid uiid", vendorProfileUiid);
    if (vendorProfileUiid) {
      console.log("getting data for current vendor for comments:::::::::");
      dispatch(
        getVendorOneStart({
          vendorUiid: vendorProfileUiid,
          retrieve: `comments`,
        })
      );
    }
  }, [vendorId]);
  useEffect(() => {
    if (vendorProfileUiid || 
      Object.keys(vendorDetails).length > 0) {
      console.log(
        "checking store and updating screen for comments:::::::::",
        vendorDetails?.comments
      );
      setComment(vendorDetails?.comments || "");
    }
    // }, [vendorDetails]);
  }, [vendorProfileUiid, Object.keys(vendorDetails).length]);
    

  const handleSave = () => {
    try {
      const prepareSubmissionData = {
        uiid: vendorProfileUiid,
        coll: `Vendor`,
        payload: [
          {
            type: "SET",
            value: {
              comments: comment,
            },
          },
        ],
      };
      dispatch(updateVendorStart({ ...prepareSubmissionData }));
      setActiveTab((prev) => prev + 1);
    } catch (error) {
      console.error("Error saving vendor comments:", error);
    }
  };
  const handleBack = () => {
    setTimeout(() => {
      // Move to back tab
      setActiveTab((prev) => prev - 1);
    }, 500);
  };


    const handleDraft = useMemo(
      () =>
        debounce((value) => {
          dispatch(
            // addToDraft({
            //   [field]: value ? value : "",
            // })
            addToDraft({ ...value })
          );
        }, 1000),
      [dispatch]
    );
    useEffect(() => {
      let vendorData = {
        comments: comment,
      };
      // if (vendorProfileUiid || Object.keys(vendorDetails).length > 0) {
      handleDraft(vendorData);
      // }
    }, [comment]);
  return (
    <div className="flex flex-col w-full h-full gap-8 px-8 py-3 overflow-auto rounded">
      <PageHeader
        Section={
          <div className="flex">
            <PageTitle title={"Comments"} icon={"badge"} tag="h5" />
          </div>
        }
        RightSection={
          <>
            {isEditable && editVendor && (
              <>
                <Button
                  title="Back"
                  size="sm"
                  icon={"arrow_left_alt"}
                  onClick={handleBack}
                />
                <Button title="Save" size="sm" onClick={handleSave} />
              </>
            )}
          </>
        }
      />
      <div className="max-w-[90%]">
        <FormFieldSet
          type={"textArea"}
          title={"Comments"}
          size="lg"
          rows={4}
          placeholder="Enter your text"
          onChange={(e) => setComment(e)}
          value={comment}
          disabled={!isEditable}
        />
      </div>
    </div>
  );
};

export default Comments;
